<script>import { trackComponent } from "@sentry/svelte";
trackComponent({ "trackInit": true, "trackUpdates": true, "componentName": "EmbedVideo" });
export let source;
export let title = "smatch video";
export let css = "";
const format = (source2) => {
    const PARAMS = "hide_share=true&hideEmbedTopBar=true&hide_owner=true&hide_title=true";
    const SOURCE = source2.replace("share/", "embed/");
    if (source2.endsWith("?")) {
        return `${SOURCE}${PARAMS}`;
    }
    if (source2.includes("?")) {
        return `${SOURCE}&${PARAMS}`;
    }
    return `${SOURCE}?${PARAMS}`;
};
</script>

{#if source !== undefined}
    <div class = { `s8-embed-video ${ css }` } >
        <iframe
            src = { format(source) }
            { title }
            frameborder = '0'
            allowfullscreen
            class = 's8-embed-video-iframe'
        />
    </div>
{/if}

<style>

    .s8-embed-video {
        position: relative;
        container-type: inline-size;
        container-name: embed-video;
        padding-bottom: 63.90532544378698%;
        height: 0;
    }

    .s8-embed-video-iframe {
        position: absolute;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
    }</style>